import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-secondary-footer',
  templateUrl: './secondary-footer.component.html',
  styleUrls: ['./secondary-footer.component.scss']
})
export class SecondaryFooterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
